import { Injectable, EventEmitter } from '@angular/core';
import { Connection, hubConnection, Proxy } from 'signalr-no-jquery';


@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private connection: Connection;
  private proxyHub: Proxy;
  downloadCompletedEvent = new EventEmitter();
  connectionEvent = new EventEmitter();
  logoutEvent = new EventEmitter();
  sendProgressFileNameEvent = new EventEmitter();
  private eventName: string;

  constructor() { }

  establishHub(proxyhubname: string, eventName: string) {
    this.connection = hubConnection();
    this.proxyHub = this.connection.createHubProxy(proxyhubname);
    this.eventName = eventName;
    this.registerOnserverEvents();
    this.startConnection();
    this.reConnect();
  }

  private startConnection(): void {
    this.connection.start()
      .done(() => {
        this.connectionEvent.emit();
      })
      .fail((error: any) => {
        console.log('Could not connect' + error);
      });
  }

  //Mozilla SignalR disconnection issue
  private reConnect(): void {
    this.connection.disconnected(() => {
      setTimeout(() => {
        this.connection.start().done(() => {
          this.proxyHub.on(this.eventName, (filename: string) => {
            setTimeout(() => {
              if (this.eventName == 'downloadComplete') {
                this.downloadCompletedEvent.emit(filename);
              }
              else if (this.eventName == 'sendProgressFileName') {
                this.sendProgressFileNameEvent.emit(filename);
              }
              else {
                this.logoutEvent.emit(filename);
              }
            }, 1000);
          });
        })
      });
    })
  }

  private registerOnserverEvents(): void {
    this.proxyHub.on(this.eventName, (filename: string) => {
      setTimeout(() => {
        if (this.eventName == 'downloadComplete') {
          this.downloadCompletedEvent.emit(filename);
        }
        else if (this.eventName == 'sendProgressFileName') {
          this.sendProgressFileNameEvent.emit(filename);
        }
        else {
          this.logoutEvent.emit(filename);
        }
      }, 1000);
    });
  }
}
